<div class="container" #container [class.container__no-absolute]="positioType" (scroll)="getScroll($event)" (mousemove)="hoverIndex($event)">

  <div class="header" [ngStyle]="{'z-index': templateIndex ? 2 : 1}" *ngIf="listHeaders.length">
    <div class="tbl-header tbl-{{item.nameClass}}" [ngClass]="{'tbm': positioType}" *ngFor="let item of listHeaders">
      <div class="tbl-name" *ngIf="item.data === 'input'">
       <lib-input-checkbox class="input-control" id="favorite" name="favorite" (click)="selectAll()"></lib-input-checkbox>
      </div>
      <p class="text-header" [ngClass]="{'tbm': positioType}" *ngIf="item.data !== 'input'">
        <app-arrow-label [value]="sortKey !== item.id ? 0 : null" (sort)="sort($event, item)" *ngIf="item.sort">
          <span>{{item.data}}</span>
        </app-arrow-label>
        <span *ngIf="!item.sort">{{item.data}}</span>
      </p>

    </div>
  </div>

  <div class="table" *ngIf="listBinding.length">

    <div class="tbl-name tbl" [ngClass]="{'tbm': positioType}">
      <div id="tbl-name-item-{{i}}" class="tbl-body" *ngFor="let data of listBinding; let i = index" 
        [ngClass]="{'tbl-hover': id === i}"   (mouseover)="hoverEvent(i)">
        <lib-input-checkbox class="input-control" id="favorite" name="favorite" [ngModel]="data.select" 
        (click)="sendItemSelections.emit({id: data.id, user_id: data.user_id, userLabel: data.userLabel, name: data.name, nickname: data.leader_nickname, select: data.select = !data.select})"></lib-input-checkbox>
      </div>
    </div>

    <div class="tbl-product tbl" >
      <div id="tbl-product-item-{{i}}" class="tbl-body" *ngFor="let data of listBinding; let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <img src="{{data.image_url}}" alt="Perfil" loading="lazy" default="../../../../assets/imgs/person.png">
        <p class="title-user" matTooltip="{{ data.userLabel }}" >{{ data.userLabel }}</p>
      </div>
    </div>

    <div class="tbl-contact tbl" *ngIf="isHoverTable">
      <div id="tbl-contact-item-{{i}}" class="tbl-body" *ngFor="let data of listBinding; let i = index" 
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <button class="btn btn-phone" id="btn-phone-{{data.id}}" 
          [matTooltip]="data.phone_ddi + ' ' + data.phone_ddd + ' ' + data.phone_number"
          (click)="copyToClipboard(data.phone_ddi + ' ' + data.phone_ddd + ' ' + data.phone_number, 'Telefone')">
          <p hidden=true>{{ data.phone_ddi }} {{ data.phone_ddi }} {{ data.phone_number }}</p>
          <img src="../../../../assets/svgs/i_phone.svg" alt="Icon Phone">
        </button>
        <button class="btn btn-email" id="btn-email-{{data.id}}" 
          [matTooltip]="data.email" 
          (click)="copyToClipboard(data.email, 'Email')">
          <p hidden=true>{{ data.emaiil }}</p>
          <img src="../../../../assets/svgs/i_email.svg" alt="Icon Email">
        </button>
      </div>      
    </div>

    <div class="tbl-market tbl" *ngIf="isHoverTable">
      <div id="tbl-market-item-{{i}}" class="tbl-body" *ngFor="let data of listBinding; let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <p class="title-user">{{ data.market }}</p>
      </div>
    </div>

    <div class="tbl-creci-expiration tbl" *ngIf="isHoverTable">
      <div id="tbl-creci-expiration-item-{{i}}" class="tbl-body" *ngFor="let data of listBinding; let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
          <span [ngClass]="{ ok: data.creci_status, expired: !data.creci_status }">-</span>
          {{ data.creci_validity }}
      </div>
    </div>

    <div class="tbl-product tbl" [class.tbl-product__enterprise]="!isHoverTable" *ngIf="!isHoverTable">
      <div id="tbl-product-item-secondary-{{i}}" class="tbl-body" *ngFor="let data of listBinding; let i = index"
      [ngClass]="{'tbl-hover': id === i}"
      (mouseover)="hoverEvent(i)">
        <p><span>{{ data.enterprise ? data.enterprise : null }}</span></p>
      </div>
    </div>   

    <div class="tbl-hover-action tbl" *ngIf="isHoverTable">
      <div class="tbl-body" id="tbl-hover-action-{{i}}"  *ngFor="let data of listBinding; let i = index"
        [ngClass]="{'tbl-hover': id === i}"  (mouseover)="hoverEvent(i)">
        <div class="btn-hover" *ngIf="id === i">
          <button id="action-op-menu" class="btn-action" [matMenuTriggerFor]="beforeMenu">
            <img src="../../../../assets/svgs/i_btn_hover_table.svg" alt="Actions">
          </button>
          <mat-menu #beforeMenu="matMenu" xPosition="before">
            <div class="item-hover" *ngFor="let item of listOptions; let i = index">
              <button mat-menu-item id="btn-opt-{{i}}" (click)="sendOptions.emit({type: data.role, user_id: data.user_id, userLabel: data.userLabel, id: data.id, name: data.nickname, nickname: data.leader_nickname, option: item.name}); isOptions = false">{{ item.name }}</button>
            </div>
          </mat-menu>
        </div>
      </div>    
    </div>
  </div>
  <ng-container *ngIf="searching">
    <div class="more-results-loading">
      <lib-loading></lib-loading>
    </div>
  </ng-container>
</div>